<template>
  <zone-table
    :value="zoneNameSearch"
    :zones="countryZones"
    :active-zone="activeCountryZone"
    @input="onSearchInput"
    @on-row-click="$emit('on-row-click', $event)"
    @on-remove-click="onRemoveButtonClick"
    @on-edit-click="onEditButtonClick"
  ></zone-table>
</template>

<script>
import debounce from 'lodash-es/debounce'
import { mapActions, mapGetters, mapState } from 'vuex'
import Swal from 'sweetalert2'
import ZoneTable from './zone-table'
import EventBus from '../event-bus'
import { divisionPopup } from './popups'

export default {
  name: 'ZoneCountryAreas',
  components: { ZoneTable },
  props: {
    zones: {
      type: Array,
      default() {
        return []
      },
    },
  },

  computed: {
    ...mapGetters('zones', ['countryZones', 'activeCountryZone']),
    ...mapState('zones', ['zoneNameSearch']),
  },

  methods: {
    ...mapActions('zones', [
      'removeCountryZone',
      'fetchCountryZones',
      'updateCountryZones',
    ]),

    onSearchInput(value) {
      this.$store.commit('zones/setZoneNameSearch', value)
      this.debouncedFetchCountryZones()
    },

    debouncedFetchCountryZones: debounce(function() {
      this.fetchCountryZones()
    }, 300),

    async onRemoveButtonClick(countryZoneForRemove) {
      const { value: yes } = await Swal({
        title: this.$t('zones.delete_confirmation'),
        type: 'question',
        showCancelButton: true,
      })

      if (yes) {
        const $t = this.$t.bind(this)
        this.removeCountryZone(countryZoneForRemove)
          .then(() => EventBus.$emit('on-zone-removed', countryZoneForRemove))
          .catch(() => {
            this.$toast.error($t('zones.delete_error_message'))
          })
      }
    },
    onEditButtonClick(countryZoneToUpdate) {
      divisionPopup(countryZoneToUpdate, this.$i18n).then(result => {
        if (result.dismiss) {
          return
        }
        countryZoneToUpdate.title = result.value.name
        countryZoneToUpdate.isNewMethod = result.value.isNewMethod
        this.updateCountryZones(countryZoneToUpdate).catch(err =>
          this.$toast.error(err.data.message),
        )
      })
    },
  },
}
</script>
